import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { task, timeout } from "ember-concurrency"

export default class Outline extends Component {
  @service("ember-store") store
  @service rpc

  //args
  onNewFocusedItemId!: Function
  focusedItemId!: string
  course!: Course
  rotationCalendar!: RotationCalendar
  planbook!: Planbook
  startDate!: string
  endDate!: string
  startedSearch!: Function
  finishedSearch!: Function
  onClearSearchQuery!: Function

  // props
  isSearching = false
  hasQuery = false
  results = []
  selectedResultId = null
  query
  _query

  hitSearchBackend = task({ keepLatest: true }, async (query) => {
    this.set("query", query)
    this.startedSearch(query)
    if (query === "" || null) {
      this.finishedSearch(null)
    } else {
      await this.rpc.execute("COURSE_SEARCH", query, this.course.id).then((data) => {
        console.log("data", data, query)
        this.finishedSearch(data.data)
      })
    }
    await timeout(30)
  })

  @action
  search(event) {
    let query = event.target.value
    if (this._query === null) this.set("_query", query)
    // @ts-ignore
    this.hitSearchBackend.perform(query)
  }

  @action
  clearSearchQuery() {
    this.set("_query", null)
    this.onClearSearchQuery()
  }
}
